import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { GestockService } from '../services/gestock.service';
import { ReponseWebService } from '../datastruct/Meloyi.module';


@Component({
  selector: 'app-modificationgenerale',
  templateUrl: './modificationgenerale.component.html',
  styleUrls: ['./modificationgenerale.component.css']
})
export class ModificationgeneraleComponent {

  donneeYi : any ;

  samacaabiyoonwii = "" ;

  retourClientWS  : ReponseWebService ;

  formulaireElts : any ;

  step = 1 ;

  toutesLesCategories: string[] = []; 

  selectedCategorie:any ;


  // data contiendra l'objet passé lors de l'ouverture du dialog
  constructor(
    public dialogRef: MatDialogRef<ModificationgeneraleComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any, 
                  private configServer: GestockService ) {

    this.donneeYi = data ;
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
    this.getInfoPourLiiWalaKii() ;

  }


  ngOnInit(): void {

  }


  trackByKey(index: number, item: any) {
    return item.key;
  }

  canDisplay(key){
    if(key!="id" && key!="pricingType" && key!="categorie")
      return true ;
    else
      return false ;    
  }


  oncategChange(event){
    this.formulaireElts.pricingType = event.value ;
  }


  getInfoPourLiiWalaKii(){
    this.configServer.getInfoPourLiiWalaKii(this.samacaabiyoonwii, 
            this.donneeYi.dataIntrinsect.id, this.donneeYi.lanelaniouySoppiLou).then( (retourbi) => {

      this.retourClientWS = retourbi ;
      console.log("Waadji wala MbirrMi :: ", this.retourClientWS) ;

      var statutreq = this.retourClientWS.statutreq;
      if(statutreq==1){
          if(this.donneeYi.lanelaniouySoppiLou=='Produit'){
            this.getAllCategories() ;
          }
          this.formulaireElts = this.retourClientWS.data ;
      }
      else{
        console.log("No One:", this.retourClientWS);
      }
    }) ;        
  }

  soppidjiilWaadji(){
    this.step = 2 ;
    this.configServer.soppidjiilWaadji(this.samacaabiyoonwii, 
            this.formulaireElts, this.donneeYi.lanelaniouySoppiLou).then( (retourbi) => {

      this.retourClientWS = retourbi ;
      console.log("Waadji wala MbirrMi Laniouy Soppi :: ", this.retourClientWS) ;

      var statutreq = this.retourClientWS.statutreq;
      if(statutreq==1){
        console.log("fait!");
        this.step = 3 ;
      }
      else{
        this.step = -3 ;
        console.log("No One:", this.retourClientWS);
      }


    }) ;        
  }


  getAllCategories(){
    this.configServer.getAllCategories(this.samacaabiyoonwii).then( (retourbi) => {
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      if(statutreq==1){
        this.toutesLesCategories = this.retourClientWS.data ;
        console.log("Done") ;
      }
      else{
        console.log("Failed") ;
      }
    }) ;        
  }



  // Fermer sans sauvegarde
  onCancel(): void {
    this.dialogRef.close(null);
  }

  // Sauvegarder et renvoyer l'objet modifié
  onSave(): void {
    console.log(this.formulaireElts) ;
    this.soppidjiilWaadji() ;
  }

  close(){
    this.dialogRef.close(null);
  }


}
